(() => {
  const overrides = [
    {
      source: 'DSC09551.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-outdoors-camping-basket-detail-2026-08-15-landscape.webp?v=1786783786',
      alt: 'PegGrid outdoor setup with a wire basket holding rolled camping gear and storage bags.'
    },
    {
      source: 'DSC09558.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-outdoors-camping-setup-detail-2026-08-15-portrait.webp?v=1786783778',
      alt: 'PegGrid outdoor setup displaying cookware and camping equipment on a black grid.'
    },
    {
      source: 'DSC09893.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-ski-snow-helmet-goggles-detail-2026-08-15-square.webp?v=1786783793',
      alt: 'PegGrid ski and snow setup with skis, helmet, goggles and integrated lighting.'
    },
    {
      source: 'DSC09487.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-product-main-grid-fitness-studio-2026-08-15-square.webp?v=1786783801',
      alt: 'PegGrid Main Grid organising fitness equipment beside a compact home studio reformer.'
    },
    {
      source: 'about_us_cover_image.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-about-creator-gear-flat-lay-2026-08-15-landscape.webp?v=1786783808',
      alt: 'PegGrid brand story flat lay of outdoor, travel, camera and everyday gear.'
    },
    {
      source: 'DSC09723.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-product-main-grid-unassembled-components-2026-08-15-square.webp?v=1786787020',
      alt: 'PegGrid Main Grid components laid out on a carpet before assembly.'
    },
    {
      source: 'endless_configuration.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-product-three-grid-configurable-storage-system-2026-08-15-square.webp?v=1786787035',
      alt: 'PegGrid three-grid storage system configured with shelves, hooks and a wire basket.'
    },
    {
      source: 'E-commerce_Product_Photo_Guidance.webp',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-ski-snow-complete-gear-setup-2026-08-15-square.webp?v=1786787029',
      alt: 'PegGrid ski and snow setup displaying skis, snowboards, helmets, boots and outerwear.'
    },
    {
      source: 'Features.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-product-grid-panel-frame-detail-2026-08-15-square.webp?v=1786787044',
      alt: 'Close-up of a PegGrid timber-look perforated panel fitted inside its black metal frame.'
    },
    {
      source: 'Web_Video_Cover.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-ski-snow-equipment-close-up-2026-08-15-square.webp?v=1786787051',
      alt: 'PegGrid ski and snow setup with skis, helmets, outerwear and camera equipment.'
    },
    {
      source: 'before.jpg',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-ski-snow-before-storage-2026-08-15-landscape.webp?v=1786787069',
      alt: 'Ski and snow equipment arranged against a wall before being organised on PegGrid.'
    },
    {
      source: 'DSC09767.webp',
      url: 'https://cdn.shopify.com/s/files/1/0778/3979/4408/files/peggrid-inspiration-outdoors-camp-kitchen-detail-2026-08-15-square.webp?v=1786787059',
      alt: 'PegGrid outdoor setup organising camp kitchen cookware, utensils, lanterns and accessories.'
    }
  ];

  const widths = [320, 480, 640, 800, 1000, 1200, 1600, 2048, 2400];
  const imageAttributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-original'];

  const valueFor = (element) => {
    const values = imageAttributes.map((attribute) => element.getAttribute(attribute) || '');
    if (element.currentSrc) values.push(element.currentSrc);
    return values.join(' ');
  };

  const findOverride = (value) => overrides.find((item) => value.includes(item.source));

  const urlAtWidth = (url, width) => {
    const next = new URL(url);
    next.searchParams.set('width', String(width));
    return next.toString();
  };

  const srcsetFor = (url) => widths.map((width) => `${urlAtWidth(url, width)} ${width}w`).join(', ');

  const applyImageOverride = (image) => {
    if (!(image instanceof HTMLImageElement)) return;

    const override = findOverride(valueFor(image));
    if (!override) return;
    if (image.dataset.peggridP1Override === override.source) return;

    const responsiveSrcset = srcsetFor(override.url);
    image.src = override.url;
    image.srcset = responsiveSrcset;
    image.alt = override.alt;
    image.dataset.peggridP1Override = override.source;

    ['data-src', 'data-original'].forEach((attribute) => {
      if (image.hasAttribute(attribute)) image.setAttribute(attribute, override.url);
    });
    if (image.hasAttribute('data-srcset')) image.setAttribute('data-srcset', responsiveSrcset);

    const picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.srcset = responsiveSrcset;
        if (source.hasAttribute('data-srcset')) source.setAttribute('data-srcset', responsiveSrcset);
      });
    }
  };

  const applyBackgroundOverride = (element) => {
    if (!(element instanceof HTMLElement)) return;
    const inlineStyle = element.getAttribute('style') || '';
    const override = findOverride(inlineStyle);
    if (!override) return;
    element.style.backgroundImage = `url("${override.url}")`;
    element.setAttribute('role', element.getAttribute('role') || 'img');
    element.setAttribute('aria-label', override.alt);
  };

  const applyWithin = (root) => {
    if (root instanceof HTMLImageElement) applyImageOverride(root);
    if (root instanceof HTMLElement) applyBackgroundOverride(root);
    if (!(root instanceof Element || root instanceof Document)) return;
    root.querySelectorAll('img').forEach(applyImageOverride);
    root.querySelectorAll('[style*="url("]').forEach(applyBackgroundOverride);
  };

  const start = () => {
    applyWithin(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') applyWithin(mutation.target);
        mutation.addedNodes.forEach((node) => applyWithin(node));
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: imageAttributes.concat('style')
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
